module.exports = __webpack_public_path__ + "static/media/image1.66321c50.jpg";